export default "__VITE_ASSET__cc49dadc__"